(() => {
  const shell = document.querySelector('[data-account-shell]');
  if (!shell) return;
  const panels = Array.from(shell.querySelectorAll('[data-account-panel]'));
  const links = Array.from(shell.querySelectorAll('[data-account-nav]'));
  function navigate(focus) {
    const route = location.hash === '#/orders' ? 'orders' : location.hash === '#/profile' ? 'profile' : 'overview';
    for (const panel of panels) panel.hidden = panel.dataset.accountPanel !== route;
    for (const link of links) {
      const active = link.dataset.accountNav === route;
      link.classList.toggle('current', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    }
    if (focus) shell.querySelector('[data-account-panel]:not([hidden]) h1')?.focus({preventScroll: true});
  }
  navigate(false);
  window.addEventListener('hashchange', () => navigate(true));
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
})();
